/**
 * Entity types that can be linked via polymorphic link tables (event_link, issue_link).
 * This allows flexible entity associations without separate junction tables per type.
 */
export enum LinkableEntityType {
	CLIENT = 'client',
	VENDOR = 'vendor',
	OPPORTUNITY = 'opportunity',
	ORDER = 'order',
	QUOTE = 'quote',
	INVOICE = 'invoice',
	ITEM = 'item',
	ISSUE = 'issue',
	LICENSE = 'license',
	SOURCING_REQUEST = 'sourcing_request',
}

export type LinkableEntityTypeValue =
	(typeof LinkableEntityType)[keyof typeof LinkableEntityType];

/**
 * Human-readable labels for linkable entity types
 */
export const LinkableEntityTypeLabels: Record<LinkableEntityType, string> = {
	[LinkableEntityType.CLIENT]: 'Client',
	[LinkableEntityType.VENDOR]: 'Vendor',
	[LinkableEntityType.OPPORTUNITY]: 'Opportunity',
	[LinkableEntityType.ORDER]: 'Order',
	[LinkableEntityType.QUOTE]: 'Quote',
	[LinkableEntityType.INVOICE]: 'Invoice',
	[LinkableEntityType.ITEM]: 'Item',
	[LinkableEntityType.ISSUE]: 'Issue',
	[LinkableEntityType.LICENSE]: 'License',
	[LinkableEntityType.SOURCING_REQUEST]: 'Sourcing Request',
};

/**
 * Get human-readable label for an entity type
 */
export function getLinkableEntityTypeLabel(
	entityType: string | null | undefined,
): string {
	if (entityType == null) {
		return '-';
	}

	return (
		LinkableEntityTypeLabels[entityType as LinkableEntityType] ?? entityType
	);
}
